import * as Styles from './styles'

type ActionButtonsProps = {
  handleClick: () => void
}

export const ActionButtons = ({ handleClick }: ActionButtonsProps) => {
  return (
    <Styles.ProgressActionButtonsContainer>
      <Styles.ButtonContainer onClick={handleClick}>
        <Styles.ActionText>Button 1</Styles.ActionText>
        <Styles.ScoreText>+15%</Styles.ScoreText>
      </Styles.ButtonContainer>
      <Styles.ButtonContainer onClick={handleClick}>
        <Styles.ActionText>Button 2</Styles.ActionText>
        <Styles.IconContainer>
          <Styles.Icon />
        </Styles.IconContainer>
      </Styles.ButtonContainer>
    </Styles.ProgressActionButtonsContainer>
  )
}
